module.exports = __webpack_public_path__ + "img/france1.083221ea.jpg";